const factoringData = (t) => ({
  name: t('factoring name'),
  titleText: 'Adelanta el pago de tus facturas con Fingo',
  subtitleText: 'Obtén liquidez inmediata sin endeudarte. Rápido, digital y sin complicaciones.',
  startTextButton: 'Anticipar facturas',
  hero_image: '/images/factoring_hero.webp',
  description_information:
  {
    image: '/images/factoring_description.webp',
    title: `¿Qué es el ${t('factoring name')}?`,
    text: 'Es una herramienta financiera que permite a las empresas transformar sus facturas por cobrar en liquidez inmediata. '
    + 'En lugar de esperar 30, 60 o incluso 90 días para recibir el pago de sus clientes, las empresas pueden ceder esas facturas a una entidad como Fingo y obtener el dinero en corto plazo. '
    + 'Esto les permite mantener una mejor liquidez, pagar a proveedores, cubrir gastos operativos o invertir en crecimiento sin depender de los plazos de pago.',
  },
  benefits_information:
  {
    image: '/images/factoring_benefits.webp',
    title: 'Beneficios de operar con Fingo',
    text: [
      'Proceso 100% digital, simple y transparente.',
      'Acceso rápido a capital de trabajo, sin papeleos innecesarios.',
      'Nuestro equipo analiza rápidamente tus facturas y, si calificas, puedes recibir el dinero el mismo día.',
      'Ahorra tiempo y recursos en la gestión de cobranza: Fingo se encarga del seguimiento de tus facturas.',
      'Sin deuda en tu historial financiero, ya que es una cesión de activos.',
    ],
  },
  requirements_information:
  {
    image: '/images/solution_requirements.webp',
    title: 'Requisitos',
    text: [
      'Ser empresa o persona natural con giro activo.',
      `Haber emitido facturas electrónicas validadas por el ${t('tax authority')}.`,
      'Más de 6 meses de facturación (negociable).',
      'Solicitar un monto de operación desde $200.000 (negociable).',
    ],
  },
});

export default factoringData;
